import { MerchantSaleUnitDto } from "../../dto/merchantSaleUnit.dto";

export interface PosOverridePosDeviceDialogResult {
  saleUnit?: MerchantSaleUnitDto;
  cartId?: number;
  posDevice?: number;
  isOverridePosDevice?: boolean;
  actionName?: string;
  params?: any;
}